<template>
  <BasicLayout :id="'four'">
    <p class="-big">
      四月，
      <br />
      <b>听说学习从二次开发开始？</b>
    </p>
    <p>获得原主人许可，开始用自己蹩脚的编码风格修改主题。</p>
    <p>也许是自己改的用起来别有一番风味。</p>

    <img
      src="https://camo.githubusercontent.com/f8ea2b199afc03dfdaf5ac07b0b5b1e590ebaaba/68747470733a2f2f7773342e73696e61696d672e636e2f6c617267652f303036744b6654636c793167316c317a3666657a316a333175663075306e70652e6a7067"
      alt
    />
  </BasicLayout>
</template>

<script>
import BasicLayout from '../BasicLayout'
export default {
  components: {
    BasicLayout
  }
}
</script>
